import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import ResourceSelect from "../../../../../components/Inputs/ResourceSelect";
import {
	getSettingsResourceSearchFilters,
	renderSettingsResourceLabel,
} from "../../../../../utils/helpers/settings";

export const useProjectFilter = () => {
	const { t } = useTranslation();

	return useMemo(
		() => ({
			id: "project",
			Header: t("project"),
			filter: "resource-select",
			canFilter: true,
			Filter: (
				<ResourceSelect
					labelPropName="description"
					renderLabel={renderSettingsResourceLabel}
					resourcePath="/project"
					hasSearch
					mode="multiple"
					getSearchFilters={getSettingsResourceSearchFilters}
				/>
			),
		}),
		[t],
	);
};
